import { Box } from '@chakra-ui/layout'
import { Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ScrollableTable from './ScrollableTable'

interface Props {
  data: AnalyticsAPIResponse
}

const TopBrowsersTable = ({ data }: Props): React.ReactElement => {
  const { t } = useTranslation()

  const browserData = data.browserDistribution

  if (!browserData || !Object.keys(browserData).length) {
    return <Box>{t('no_data_available', 'No Data Available')}</Box>
  }

  const tableRows = browserData.map(item => {
    if (!item.name || !item.count) {
      return null
    }

    let name = ''
    try {
      name = decodeURI(item.name)
    } catch (err) {
      name = item.name
    }

    return (
      <Tr key={item.name}>
        <Td>{name}</Td>
        <Td>
          {`${numeral(item.count)
            .format('0.0 a')
            .toUpperCase()} requests (${numeral(item.bandwidth)
            .format('0.0 ib')
            .replace('i', '')})`}
        </Td>
      </Tr>
    )
  })

  return (
    <ScrollableTable>
      <Thead>
        <Tr>
          <Th>{t('broswer', 'Broswer')}</Th>
          <Th>{t('usage', 'Usage')}</Th>
        </Tr>
      </Thead>
      <Tbody>{tableRows}</Tbody>
    </ScrollableTable>
  )
}

export default TopBrowsersTable
